@if (errors.error(); as err) {
<div class="error-overlay">
  <div class="error-card">
    <p class="error-eyebrow">Something went wrong</p>
    <h2 class="error-title">{{ title }}</h2>
    <p class="error-message">{{ err.message }}</p>
    <div class="error-actions">
      <app-button variant="primary" (click)="reset()">Try again</app-button>
      <app-button variant="ghost" (click)="dismiss()">Dismiss</app-button>
    </div>
  </div>
</div>
} @else {
<ng-content></ng-content>
}
